/* eslint-disable */
export default  {
  applicationKey: '00000-00000-00000-00000-00132',
  API_KEY:  'AIzaSyAkjzNdK2Mf_O4z6iWHBrea3ncwcyjyJtM',
  POS_APIURL: (process.env.NODE_ENV === "development") ? 'http://sandbox.ioihan.com:9040'  : 'http://sandbox.ioihan.com:9040'
}
